import { connect } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import Login from 'src/components/riders/rider-portal/authentication/Login'
import {
  generateOtpAndSendViaEmail,
  generateOtpAndSendViaSms,
  getCurrentUserInfo,
  updateDeviceToken,
  verifyOtpCode
} from 'src/state/actions/rider-portal'
import { IStoreState } from 'src/types'
import { IRiderAuthDetails, IUserDeviceToken } from 'src/types/rider-portal'

export function mapStateToProps(state: IStoreState, ownProps: Record<string, unknown>): Record<string, unknown> {
  return {}
}

export function mapDispatchToProps(dispatch: ThunkDispatch<IStoreState, unknown, AnyAction>) {
  return {
    generateOneTimePassword: (riderDetails: IRiderAuthDetails) => {
      const { countryCode, otpRecipient, phoneNumber } = riderDetails
      return otpRecipient === 'sms'
        ? dispatch(generateOtpAndSendViaSms({ countryCode, phoneNumber }))
        : dispatch(generateOtpAndSendViaEmail({ countryCode, phoneNumber }))
    },
    getCurrentUserInfo: (userId: string) => {
      return dispatch(getCurrentUserInfo(userId))
    },
    updateDeviceToken: (deviceToken: IUserDeviceToken) => {
      return dispatch(updateDeviceToken(deviceToken))
    },
    verifyOtpCode: (riderDetails: IRiderAuthDetails) => {
      return dispatch(verifyOtpCode(riderDetails))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/containers/riders/rider-portal/authentication/Login.ts